import { atom } from "recoil";
import { NavLink } from "../types/navLink";

export const projectLinkState = atom<NavLink>({
  key: "projectLinkstate",
  default: {} as NavLink,
});